export const CLIENT_ID = process.env['REACT_APP_CLIENT_ID'] as string
